
import { requests } from '.'
import { Product } from '../commons/Const';
import ListData from '../models/List.model';
import PaymentHistory from '../models/PaymentHistory.model';
import Token from '../models/Token.model';
import User from '../models/User.model';
import UserCoupon from '../models/UserCoupon.model';
import UserSubscription from '../models/UserSubscription.model';
import { AdditionalPayment } from '../pages/payment/payment.viewmodel';

export const UserApi = {
  getMe: () => requests.get<User>('v1/user/me'),  

  startSubscription: (productId: number, payMethod: number, data: any) => requests.post<any>(`v1/user/me/subscription`, {productId, payMethod, data}),
  cancelSubscription: () => requests.delete<any>(`v1/user/me/subscription`),

  getSubscription: () => requests.get<UserSubscription>(`v1/user/me/subscription`),
  getPaymentHistoryList: (params?: {
    userSubscriptionId?: number
    paymentStatus?: string
  }) => requests.get<PaymentHistory[]>(`v1/user/me/payment-history`, params),

  modifyPaymentInfo: (customer_uid: string) => requests.patch<any>(`v1/user/me/payment-info`, {customer_uid}),
  changeSubscriptionAmount: (productId: number) => requests.patch<any>(`v1/user/me/change-amount`, {productId}),

  getPayment: (uuid: string) => requests.get<AdditionalPayment>(`v1/user/me/payment`, {uuid}),

  registerCoupon: (code: string) => requests.post<any>('v1/user/me/coupon', {code}),
  getCouponList: () => requests.get<UserCoupon[]>(`v1/user/me/coupon`),

  additionalPayment: (params: {
    uuid: string, 
    productId: number
    payMethod: number
    data: any
  }) => requests.post<any>('v1/user/me/additional-payment', params),

  rePayment: () => requests.post<any>('v1/user/me/re-payment'),

  resetPassword: (originPassword: string, newPassword: string) => requests.patch<any>(`v1/user/me/reset-password`, {originPassword, newPassword}),
  withdrawal: () => requests.delete<any>(`v1/user/me/withdrawal`),
};